import { SecureDocument } from '../models/secureDocument';
import { DocumentType } from './whatsappRequest';
export class DocumentViewRequest {
    Document : SecureDocument;
    DocType: DocumentType;
}